<div *ngIf="inputFields">
    <form [formGroup]="contentForm" #formDirective="ngForm"
        (ngSubmit)="submitInlineForm(contentForm.value, formDirective)" class="w-100">
            <app-inputs-generator [fGroup]="contentForm" [inputFields]="inputFields" [layout]="layout"
            [dateToFromLayout]="dateToFromLayout" [checkboxLayout]="checkboxLayout"></app-inputs-generator>
    </form>
</div>
